export function initRunningLine(options) {
  var settings = options || {};
  var roots = Array.from(
    settings.rootElements ||
      document.querySelectorAll(settings.rootSelector || ".line__runing"),
  );

  if (!roots.length) {
    return;
  }

  roots.forEach(function (root) {
    var track = root.querySelector(
      settings.trackSelector || ".line__runing-track",
    );
    var item = root.querySelector(
      settings.itemSelector || ".line__runing-item",
    );

    if (!track || !item) {
      return;
    }

    var spacing = settings.spacing || "   ";
    var baseText = item.textContent.trim();
    item.textContent = baseText + spacing;

    var containerWidth = root.offsetWidth;
    var repeatMultiplier = settings.repeatMultiplier || 2;
    var maxCopies = settings.maxCopies || 30;
    var safety = 0;

    while (
      track.scrollWidth < containerWidth * repeatMultiplier &&
      safety < maxCopies
    ) {
      track.appendChild(item.cloneNode(true));
      safety += 1;
    }

    var halfWidth = track.scrollWidth;
    var clones = Array.from(track.children).map(function (node) {
      return node.cloneNode(true);
    });

    clones.forEach(function (node) {
      track.appendChild(node);
    });

    var minDuration = settings.minDuration || 12;
    var speedDivisor = settings.speedDivisor || 500;
    var durationVarName = settings.durationVarName || "--line-running-duration";
    var duration = Math.max(minDuration, halfWidth / speedDivisor);

    track.style.setProperty(durationVarName, duration + "s");
  });
}
